export const UPDATE_THIRD_PARTY = 'UPDATE_THIRD_PARTY';

export const updateThirdParty = ({ comScore: comScoreData }) => ({
    type: UPDATE_THIRD_PARTY,
    payload: { comScoreData },
});

export default (state = {}, action) =>
    action.type === UPDATE_THIRD_PARTY ? { ...state, ...action.payload } : state;
